/**
 *
 * WaveIcon
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
// import styled from 'styled-components';

function WaveIcon(props) {
  return (
    <div className="hdg-wave">
      <i className="icon icon--squiggle-dark about-team__icon hide-desktop" />
      <i className="icon icon--squiggle hdg-wave__icon hide-mobile" />
      <span className="hdg-wave__text cursive-font">{props.children}</span>
      <i className="icon icon--squiggle-dark about-team__icon hide-desktop" />
    </div>
  );
}

WaveIcon.propTypes = {
  children: PropTypes.node.isRequired,
};

export default WaveIcon;
